"use client";

import * as React from "react";

/**
 * prefers-reduced-motion sem divergência de hidratação: `false` no servidor e no
 * primeiro render do cliente; atualiza logo após a montagem. Use para alterar
 * comportamento (timers, listeners) — para layout, prefira CSS @media.
 */
export function usePrefersReducedMotion() {
  const [reduced, setReduced] = React.useState(false);
  React.useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduced(mq.matches);
    const onChange = (e: MediaQueryListEvent) => setReduced(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return reduced;
}
